import { DEVICE_RESOLUTION } from "../../app-constants";
import React, { useEffect, useState } from "react";

const ChristmasRaffleNavMenu = () => {
  const [isMobile, setIsMobile] = useState(
    window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth >= DEVICE_RESOLUTION.MobileMin && window.innerWidth < DEVICE_RESOLUTION.Laptop);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <div className="mt-3 lg:mt-4">
        <a href={"/big-7-draws"} title={"Christmas Draws"} className={"cursor-pointer"}>
          <img
            src={
              isMobile
                ? "/assets/images/leaderboard/nav-big-7-draws-m.png"
                : "/assets/images/leaderboard/nav-big-7-draws-d.png"
            }
            alt="Christmas Draws"
            className="w-full h-auto rounded-lg"
          />
        </a>
      </div>
    </>
  );
};

export default ChristmasRaffleNavMenu;
